import { CommandItem } from '@/code/frontend/components/ui/command';
import type { LookupCommand } from '../types';

interface CmdKLookupCommandItemProps {
  command: LookupCommand;
  onSelect: () => void;
}

/**
 * A lookup command option (e.g., "lead:", "campaign:") in the CmdK dialog.
 */
export function CmdKLookupCommandItem({
  command,
  onSelect,
}: CmdKLookupCommandItemProps) {
  const Icon = command.icon;

  return (
    <CommandItem
      value={command.prefix}
      onSelect={onSelect}
      className="flex items-center gap-3"
    >
      <Icon className="h-4 w-4 text-muted-foreground" />
      <div className="flex-1">
        <span className="font-mono">{command.prefix}</span>
        <span className="text-muted-foreground ml-2 text-sm">
          {command.description}
        </span>
      </div>
      <kbd className="px-1.5 py-0.5 rounded bg-muted font-mono text-xs text-muted-foreground">
        Tab
      </kbd>
    </CommandItem>
  );
}
